import React from 'react';

const NotFoundPage = () => {
    const style = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: '#f2f2f2',
        },
        title: {
            fontSize: '2rem',
            color: '#333',
        },
        text: {
            fontSize: '1.5rem',
            color: '#666',
            marginTop: '1rem',
            textAlign: 'center',
        },
    };

    return (
        <div style={style.container}>
            <h2 style={style.title}>404 - Page Not Found</h2>
            <p style={style.text}>
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
        </div>
    );
};

export default NotFoundPage;